import __request__ from "routing/request";
export function getConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.cloud/auth/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
